export class DefaultMeasurementType {
  sensor: string;
  unit: string;
  dataType: string;

  constructor(sensor?: string, unit?: string, dataType?: string) {
    this.sensor = sensor;
    this.unit = unit;
    this.dataType = dataType;
  }
}
